/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: kAWnPiDkalqP

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Logo from "../../Logo"; // plasmic-import: 2Sac1UHK8925/component
import RoundButton from "../../RoundButton"; // plasmic-import: G_YIM-U5ADf4/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicAccordionSectionHeader.module.css"; // plasmic-import: kAWnPiDkalqP/css

import Icon64Icon from "./icons/PlasmicIcon__Icon64"; // plasmic-import: WzuZ8AOmVWTQ/icon

createPlasmicElementProxy;

export type PlasmicAccordionSectionHeader__VariantMembers = {
  active: "active";
  order: "first" | "last";
};
export type PlasmicAccordionSectionHeader__VariantsArgs = {
  active?: SingleBooleanChoiceArg<"active">;
  order?: SingleChoiceArg<"first" | "last">;
};
type VariantPropType = keyof PlasmicAccordionSectionHeader__VariantsArgs;
export const PlasmicAccordionSectionHeader__VariantProps =
  new Array<VariantPropType>("active", "order");

export type PlasmicAccordionSectionHeader__ArgsType = {
  title?: string;
  product?: string;
  onClick?: () => void;
};
type ArgPropType = keyof PlasmicAccordionSectionHeader__ArgsType;
export const PlasmicAccordionSectionHeader__ArgProps = new Array<ArgPropType>(
  "title",
  "product",
  "onClick"
);

export type PlasmicAccordionSectionHeader__OverridesType = {
  header?: Flex__<"div">;
  text?: Flex__<"div">;
  myEvaluationsLogo?: Flex__<typeof Logo>;
  myCmeLogo?: Flex__<typeof Logo>;
  myGmeLogo?: Flex__<typeof Logo>;
  right?: Flex__<"div">;
  desc?: Flex__<"h5">;
  btn?: Flex__<"div">;
  roundButton?: Flex__<typeof RoundButton>;
  arrowIcon?: Flex__<"svg">;
};

export interface DefaultAccordionSectionHeaderProps {
  title?: string;
  product?: string;
  onClick?: () => void;
  active?: SingleBooleanChoiceArg<"active">;
  order?: SingleChoiceArg<"first" | "last">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicAccordionSectionHeader__RenderFunc(props: {
  variants: PlasmicAccordionSectionHeader__VariantsArgs;
  args: PlasmicAccordionSectionHeader__ArgsType;
  overrides: PlasmicAccordionSectionHeader__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "active",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.active
      },
      {
        path: "order",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.order
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"header"}
      data-plasmic-override={overrides.header}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.header,
        {
          [sty.headeractive]: hasVariant($state, "active", "active"),
          [sty.headeractive_order_last]:
            hasVariant($state, "order", "last") &&
            hasVariant($state, "active", "active"),
          [sty.headerorder_first]: hasVariant($state, "order", "first"),
          [sty.headerorder_last]: hasVariant($state, "order", "last")
        }
      )}
      onClick={async event => {
        const $steps = {};

        $steps["runOnClick"] = true
          ? (() => {
              const actionArgs = { eventRef: $props["onClick"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["runOnClick"] != null &&
          typeof $steps["runOnClick"] === "object" &&
          typeof $steps["runOnClick"].then === "function"
        ) {
          $steps["runOnClick"] = await $steps["runOnClick"];
        }
      }}
    >
      <div
        data-plasmic-name={"text"}
        data-plasmic-override={overrides.text}
        className={classNames(projectcss.all, sty.text)}
      >
        {(() => {
          try {
            return $props.product === "myEvaluations";
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return true;
            }
            throw e;
          }
        })() ? (
          <Logo
            data-plasmic-name={"myEvaluationsLogo"}
            data-plasmic-override={overrides.myEvaluationsLogo}
            className={classNames("__wab_instance", sty.myEvaluationsLogo, {
              [sty.myEvaluationsLogoactive]: hasVariant(
                $state,
                "active",
                "active"
              )
            })}
            grayscale={(() => {
              try {
                return !$state.active;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return [];
                }
                throw e;
              }
            })()}
            hoverText={"MyEvaluations"}
            product={(() => {
              try {
                return $props.product;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "myEvaluations";
                }
                throw e;
              }
            })()}
          />
        ) : null}
        {(() => {
          try {
            return $props.product === "myCme";
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return false;
            }
            throw e;
          }
        })() ? (
          <Logo
            data-plasmic-name={"myCmeLogo"}
            data-plasmic-override={overrides.myCmeLogo}
            className={classNames("__wab_instance", sty.myCmeLogo)}
            grayscale={(() => {
              try {
                return !$state.active;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return [];
                }
                throw e;
              }
            })()}
            hoverText={"MyCME"}
            product={(() => {
              try {
                return $props.product;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "myEvaluations";
                }
                throw e;
              }
            })()}
          />
        ) : null}
        {(() => {
          try {
            return $props.product === "myGme";
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return false;
            }
            throw e;
          }
        })() ? (
          <Logo
            data-plasmic-name={"myGmeLogo"}
            data-plasmic-override={overrides.myGmeLogo}
            className={classNames("__wab_instance", sty.myGmeLogo)}
            grayscale={(() => {
              try {
                return !$state.active;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return [];
                }
                throw e;
              }
            })()}
            hoverText={"MyGME FISCAL"}
            product={(() => {
              try {
                return $props.product;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "myEvaluations";
                }
                throw e;
              }
            })()}
          />
        ) : null}
        <div
          data-plasmic-name={"right"}
          data-plasmic-override={overrides.right}
          className={classNames(projectcss.all, sty.right, {
            [sty.rightactive]: hasVariant($state, "active", "active"),
            [sty.rightorder_first]: hasVariant($state, "order", "first"),
            [sty.rightorder_last]: hasVariant($state, "order", "last")
          })}
        >
          <h5
            data-plasmic-name={"desc"}
            data-plasmic-override={overrides.desc}
            className={classNames(
              projectcss.all,
              projectcss.h5,
              projectcss.__wab_text,
              sty.desc,
              { [sty.descactive]: hasVariant($state, "active", "active") }
            )}
          >
            <React.Fragment>{$props.title}</React.Fragment>
          </h5>
        </div>
      </div>
      <div
        data-plasmic-name={"btn"}
        data-plasmic-override={overrides.btn}
        className={classNames(projectcss.all, sty.btn)}
      >
        <RoundButton
          data-plasmic-name={"roundButton"}
          data-plasmic-override={overrides.roundButton}
          ariaLabel={"Expand product accordion"}
          className={classNames("__wab_instance", sty.roundButton, {
            [sty.roundButtonactive]: hasVariant($state, "active", "active")
          })}
          color={hasVariant($state, "active", "active") ? "primary" : "gray"}
          icon={
            <Icon64Icon
              data-plasmic-name={"arrowIcon"}
              data-plasmic-override={overrides.arrowIcon}
              className={classNames(projectcss.all, sty.arrowIcon, {
                [sty.arrowIconactive]: hasVariant($state, "active", "active")
              })}
              role={"img"}
            />
          }
          notInteractable={
            hasVariant($state, "active", "active") ? true : undefined
          }
          size={"small"}
        />
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  header: [
    "header",
    "text",
    "myEvaluationsLogo",
    "myCmeLogo",
    "myGmeLogo",
    "right",
    "desc",
    "btn",
    "roundButton",
    "arrowIcon"
  ],
  text: [
    "text",
    "myEvaluationsLogo",
    "myCmeLogo",
    "myGmeLogo",
    "right",
    "desc"
  ],
  myEvaluationsLogo: ["myEvaluationsLogo"],
  myCmeLogo: ["myCmeLogo"],
  myGmeLogo: ["myGmeLogo"],
  right: ["right", "desc"],
  desc: ["desc"],
  btn: ["btn", "roundButton", "arrowIcon"],
  roundButton: ["roundButton", "arrowIcon"],
  arrowIcon: ["arrowIcon"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  header: "div";
  text: "div";
  myEvaluationsLogo: typeof Logo;
  myCmeLogo: typeof Logo;
  myGmeLogo: typeof Logo;
  right: "div";
  desc: "h5";
  btn: "div";
  roundButton: typeof RoundButton;
  arrowIcon: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicAccordionSectionHeader__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicAccordionSectionHeader__VariantsArgs;
    args?: PlasmicAccordionSectionHeader__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicAccordionSectionHeader__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicAccordionSectionHeader__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAccordionSectionHeader__ArgProps,
          internalVariantPropNames: PlasmicAccordionSectionHeader__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAccordionSectionHeader__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "header") {
    func.displayName = "PlasmicAccordionSectionHeader";
  } else {
    func.displayName = `PlasmicAccordionSectionHeader.${nodeName}`;
  }
  return func;
}

export const PlasmicAccordionSectionHeader = Object.assign(
  // Top-level PlasmicAccordionSectionHeader renders the root element
  makeNodeComponent("header"),
  {
    // Helper components rendering sub-elements
    text: makeNodeComponent("text"),
    myEvaluationsLogo: makeNodeComponent("myEvaluationsLogo"),
    myCmeLogo: makeNodeComponent("myCmeLogo"),
    myGmeLogo: makeNodeComponent("myGmeLogo"),
    right: makeNodeComponent("right"),
    desc: makeNodeComponent("desc"),
    btn: makeNodeComponent("btn"),
    roundButton: makeNodeComponent("roundButton"),
    arrowIcon: makeNodeComponent("arrowIcon"),

    // Metadata about props expected for PlasmicAccordionSectionHeader
    internalVariantProps: PlasmicAccordionSectionHeader__VariantProps,
    internalArgProps: PlasmicAccordionSectionHeader__ArgProps
  }
);

export default PlasmicAccordionSectionHeader;
/* prettier-ignore-end */
